import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { OmniSearchComponent } from 'src/app/shared-components/omni-search/omni-search.component';
import { ToggleSidenav } from 'src/shared/state/main.action';
import { MainState } from 'src/shared/state/main.state';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	imports: [
		CommonModule,
		FlexLayoutModule,
		MatButtonModule,
		MatIconModule,
		MatProgressBarModule,
		OmniSearchComponent,
		RouterModule,
	],
})
export class HeaderComponent {
	private store = inject(Store);

	public icon: Observable<string> = this.store.select(MainState.pageIcon);
	public title: Observable<string> = this.store.select(MainState.pageTitle);
	loading: Observable<boolean> = this.store.select(MainState.loading);

	toggle(): void {
		this.store.dispatch(new ToggleSidenav());
	}
}
